/**
 * The oddschecker wordmark, shared by the header (through each app's `renderLogo`), cx-footer and
 * RootErrorPage. It lives beside those composites rather than in a primitives bucket because they are
 * its only consumers.
 *
 * The `<picture>` markup was inherited from the deleted `primitives/Picture` (NGF-7059) and is kept
 * exactly as it shipped. Two deliberate oddities:
 *  - the `<img>` carries no `src`; the webp `<source>` is the only candidate.
 *  - `fetchPriority`/`loading` make this an eager LCP-eligible fetch, which is the whole reason the
 *    old `priority` prop existed and the reason this markup is not a plain `<img>`.
 *
 * Keep it CSS-module-free: ErrorContent renders it inside the `composites/RootErrorPage/render` entry,
 * which apps/proxy executes from `dist` with no exported stylesheet. See that entry's header.
 */
export const Logo: React.FC<{ resourcesUrl: string }> = ({ resourcesUrl }) => {
  return (
    <picture>
      <source srcSet={`${resourcesUrl}/assets/img/OC_LOGO_2.webp?w=213&h=34&fm=webp&q=80`} type="image/webp" />
      <img alt="Oddschecker Logo" fetchPriority="high" height={34} loading="eager" width={213} />
    </picture>
  );
};
